import React from "react";
import {
  Alert,
  Box,
  Button,
  Container,
  Grid,
  Paper,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";

//* API
import { loginUser } from "../../api/auth";

//* Auth
import { saveLoginData } from "../../useAuth";

//* Validation
import { LoginValidate } from "../../utils/validateForm";

//* Notification
import { useNotification } from "../../context/notification.context";

type LoginType = {
  username: string;
  password: string;
};

export const LoginPage: React.FC<{}> = () => {
  const { getError } = useNotification();
  const [loading, setLoading] = React.useState(false);
  const [authWarning, setAuthWarning] = React.useState("");
  const [loginData, setLoginData] = React.useState<LoginType>({
    username: "",
    password: "",
  });

  React.useEffect(() => {
    const warning = localStorage.getItem("auth_warning");
    if (warning) {
      setAuthWarning(warning);
      localStorage.removeItem("auth_warning");
    }
  }, []);

  const dataLogin = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLoginData({ ...loginData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    try {
      await LoginValidate.validate(loginData);
      setLoading(true);
      
      const response = await loginUser({
        username: loginData.username.trim(),
        password: loginData.password,
      });
      
      // Guardar datos y redirigir con recarga completa para que HomePage lea el nuevo estado
      saveLoginData(response);
      window.location.href = "/";
    } catch (error: any) {
      // Extraer mensaje de error de diferentes estructuras posibles
      const errorMessage = 
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Usuario o contraseña incorrectos";
      getError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <Container maxWidth="sm">
      <Grid
        container
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ minHeight: "100vh" }}
      >
        <Grid item style={{ minHeight: "50vh"}}>
          <Paper sx={{ padding: "1.2em", borderRadius: "0.5em" }}>
            <Typography sx={{ mb: 1 }} variant="h4">
              Iniciar Sesión
            </Typography>
            {authWarning ? (
              <Alert severity="warning" sx={{ mt: 1, mb: 1.5 }}>
                {authWarning}
              </Alert>
            ) : null}
            <Box>
              <TextField
                name="username"
                margin="normal"
                type="text"
                fullWidth
                label="Usuario"
                sx={{ mt: 2, mb: 1.5 }}
                onChange={dataLogin}
                onKeyPress={handleKeyPress}
                disabled={loading}
              />
              <TextField
                name="password"
                margin="normal"
                type="password"
                fullWidth
                label="Password"
                sx={{ mt: 1.5, mb: 1.5 }}
                onChange={dataLogin}
                onKeyPress={handleKeyPress}
                disabled={loading}
              />

              <Button
                fullWidth
                type="submit"
                variant="contained"
                sx={{ mt: 1.5, mb: 3 }}
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} color="inherit" /> : "Acceder"}
              </Button>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};
